import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetPersonnelListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    columnChooser: ColumnChooserModel[] | undefined
    currentPage: number
    sortColumn?: string
    sortDirection?: string
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
    /** Excel "Seçilenler" için işaretli kayıtlar. */
    ids?: string[]
}

export const initialGetPersonnelListPagingAndFilterRequest: GetPersonnelListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    columnChooser: undefined,
    sortColumn: undefined,
    sortDirection: undefined,
    columnFilters: []
}